export default "__VITE_ASSET__CH8AbCA9__"